import { HttpClient } from '../../apiCalls/httpClient';
import { showToast } from '../util/showToast';
import store from '../store';
import * as initVal from '../actions/initializeValues';
import { updateContainerOnResponse } from '../actions/index';

const saveEvent = (eventMessage) => ({
  eventType: 'SAVE_B3_FORM',
  eventTime: Date.now(),
  eventMessage,
});

const savePGAEvent = (eventMessage) => ({
  eventType: 'SAVE_B3_PGA_FORM',
  eventTime: Date.now(),
  eventMessage,
});

const deleteEvent = (eventMessage) => ({
  eventType: 'DELETE_B3_ENTITY',
  eventTime: Date.now(),
  eventMessage,
});

const buildRequestAddress = (storeAddress) => {
  if (!storeAddress) return [];
  let addressInfo = [];
  for (let type in storeAddress) {
    if (type === 'STREET_NAME') {
      let splitStreet = storeAddress[type].split(' ');
      if (parseInt(splitStreet[0])) {
        addressInfo.push({
          type: 'STREET_NUMBER',
          information: splitStreet[0],
        });
        addressInfo.push({
          type: 'STREET_NAME',
          information: splitStreet.slice(1).join(' '),
        });
      } else {
        addressInfo.push({
          type: 'STREET_NUMBER',
          information: '',
        });
        addressInfo.push({
          type: 'STREET_NAME',
          information: splitStreet.join(' '),
        });
      }
    } else {
      addressInfo.push({
        type: type,
        information: storeAddress[type],
      });
    }
  }
  return addressInfo;
};

export const HttpPostRequest = (requestParams) => {
  return HttpClient.post(requestParams)
    .then((res) => {
      if (res.data.eventMessage.code && res.data.eventMessage.code !== 200) {
        console.error(
          'errorCode :' + res.data.eventMessage.code,
          'eventMessage :' + res.data.eventMessage.msg
        );
        showToast('Data not saved, try again after sometime!');
      }
      return res;
    })
    .catch((error) => {
      console.error(error);
      showToast('Something went wrong, Check your network connection!');
    });
};
/** Start: Save Importer Information*/
export const saveImporterName = (name, importerId) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      name,
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
export const saveImporterNo = (importerNo, importerId) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      importerNo,
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
export const saveImporterAddress = (address, importerId) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      addressInfo: buildRequestAddress(address),
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveImporterAddressAndName = (name, address, importerId) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      addressInfo: buildRequestAddress(address),
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveImporterField = (field, value) => {
  let dataSent = saveEvent({
    importer: {
      [field]: value,
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
/**End Save Importer Detail */

/** Start: Save Consignee Information*/
export const saveConsigneeName = (name, consigneeId) => {
  let dataSent = saveEvent({
    importer: {
      consignee: {
        consigneeId,
        name,
      },
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
export const saveConsigneeNo = (consigneeNo, consigneeId) => {
  let dataSent = saveEvent({
    importer: {
      consignee: {
        consigneeId,
        consigneeNo,
      },
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveVendorName = (invoiceId, vendorId, vendorName) => {
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      invoices: [
        {
          invoiceId,
          vendorId,
          vendorName,
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveVendorAddress = (invoiceId, vendorId, address) => {
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      invoices: [
        {
          invoiceId,
          vendorId,
          addressInfo: buildRequestAddress(address),
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveConsigneeAddress = (address, consigneeId) => {
  let dataSent = saveEvent({
    importer: {
      consignee: {
        consigneeId,
        addressInfo: buildRequestAddress(address),
      },
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveConsigneeAddressAndName = (name, address, consigneeId) => {
  let dataSent = saveEvent({
    importer: {
      consginee: {
        consigneeId,
        addressInfo: buildRequestAddress(address),
      },
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveConsigneeField = (field, value) => {
  let dataSent = saveEvent({
    importer: {
      [field]: value,
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
/**End Save Consginee Detail */

export const saveDescriptionOfMerchandiseField = (field, value) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      [field]: value,
    },
    shipmentId: window.shipmentId,
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const saveDescriptionOfInvoiceField = (field, value) => {
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      [field]: value,
    },
    shipmentId: window.shipmentId,
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const saveDescriptionOfInvoiceItem = (invoiceId, field, value, formType) => {
  if (value === true) value = 1;
  else if (value === false) value = 2;
  else if (value === 'NONE') value = '_BLANK_';
  if (typeof value == 'string') value = value.trim();
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      invoices: [
        {
          invoiceId,
          [field]: value,
        },
      ],
    },
    shipmentId: window.shipmentId,
    formType
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const saveDescriptionOfMerchandiseLineItem = (
  invoiceId,
  merchandiseId,
  merchandiseDutyId,
  field,
  value,
  formType
) => {
  if (value === true) value = 1;
  else if (value === false) value = 2;
  else if (value === 'NONE') value = '_BLANK_';
  if (typeof value == 'string') value = value.trim();
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          invoiceId,
          merchandiseId,
          merchandiseDutyId,
          [field]: value,
        },
      ],
    },
    shipmentId: window.shipmentId,
    formType
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const savePgaDetailsdata = (invoiceId, merchandiseId, field, value) => {
  if (value === true) value = 1;
  else if (value === false) value = 2;
  else if (value === 'NONE') value = '_BLANK_';
  if (typeof value == 'string') value = value.trim();
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          invoiceId,
          merchandiseId,
          [field]: value,
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
export const saveTranactionNumberField = (field, value) => {
  let dataSent = saveEvent({
    [field]: value,
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveCargoControlNumberField = (field, value) => {
  let dataSent = saveEvent({
    [field]: value,
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveDeclarationSectionField = (field, value, requestId) => {
  let dataSent = saveEvent({
    declaration: {
      [field]: value,
    },
    requestId: requestId,
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveCargoSectionField = (field, value) => {
  let dataSent = saveEvent({
    cargoInfo: {
      [field]: value,
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveSubHrdSectionField = (field, value, requestId, formType) => {
  if (field !== 'totalVFD' && field !=="releaseDate") {
    value = value === '' ? '_BLANK_' : value;
    let obj = {
      shipmentId: window.shipmentId,
      requestId: requestId || window.requestId,
      subHdr: {
        [field]: value,
      },
      formType
    };

    let dataSent = saveEvent(obj);
    if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
      return HttpPostRequest(dataSent);
    }
  }
};
export const removeContainerNumber = (containerid) => {
  let obj = {
    shipmentId: window.shipmentId,
    subHdr: {
      containers: [
        {
          containerid: containerid,
        },
      ],
    },
  };
  let dataSent = deleteEvent(obj);
  return HttpPostRequest(dataSent);
};
export const saveContainerNumberField = (
  containerid,
  containerNumber,
  requestId
) => {
  let obj = {
    shipmentId: window.shipmentId,
    requestId: requestId,
    subHdr: {
      containers: [
        {
          containerNumber: containerNumber,
          containerid: containerid,
        },
      ],
    },
  };
  let dataSent = saveEvent(obj);
  return HttpPostRequest(dataSent).then((response) => {
    if (!containerid) {
      if (response.data.eventMessage.subHdr) {
        store.dispatch(
          updateContainerOnResponse(
            response.data.eventMessage.subHdr.containers
          )
        );
      } else {
        console.error(response.data.eventMessage);
      }
    }
  });
};

export const saveTotalsSectionField = (field, value) => {
  value = value === '' ? '_BLANK_' : value;
  let obj = {
    shipmentId: window.shipmentId,
    totals: {
      [field]: value,
    },
  };
  let dataSent = saveEvent(obj);
  return HttpPostRequest(dataSent);
};

export const saveTotals = (totalObj) => {
  if (window.typeOfUser === 'BROKER_KN_ADMIN') {
    return false;
  }
  let obj = {
    shipmentId: window.shipmentId,
    totals: totalObj,
  };
  let dataSent = saveEvent(obj);
  return HttpPostRequest(dataSent).then((response) => {
    store.dispatch(initVal.initializeValuesTotalsSection(totalObj));
  });
};

export const saveMerchandiseMultipleFeilds = (obj) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [obj],
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};
export const saveMerchandiseCBSAFormFields = (obj) => {
  let dataSent = saveEvent(obj);
  return HttpPostRequest(dataSent);
};

export const saveLineItemWiseCalculation = (obj) => {
  if (window.typeOfUser === 'BROKER_KN_ADMIN') {
    return false;
  }
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          invoiceId: obj.invoiceId,
          merchandiseId: obj.merchandiseId,
          merchandiseDutyId: obj.merchandiseDutyId,
          currencyConversionVal: obj.currencyConversionVal,
          valueForDuty: obj.valueForDuty,
          customsDuties: obj.customsDuties,
          gst: obj.gst,
          totalForTax: obj.totalForTax,
          total: `${obj.total?.toFixed(2)}`,
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

const savePGAFormEvent = (eventMessage) => ({
  eventType: 'SAVE_B3_PGA_FORM',
  eventTime: Date.now(),
  eventMessage,
});
export const savePgaData = (eventMessage) => {
  let payload = {
    eventType: 'SAVE_B3_PGA_FORM',
    eventTime: Date.now(),
    eventMessage,
  };
  return HttpPostRequest(payload);
};

// Saves a PGA Item Array
export const savePGAItemField = (
  PGAItemsArray,
  merchandiseId,
  formType,
  level,
  invoiceId
) => {
  let dataSent;
  if (level === 0) {
    dataSent = savePGAFormEvent({
      level: level,
      invoiceId,
      merchandiseId,
      shipmentId: window.shipmentId,
      deltaUpdate: true,

      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType: PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
          },
        ],
      },
    });
  } else if (level === 1) {
    dataSent = savePGAFormEvent({
      level: level,
      deltaUpdate: true,
      invoiceId,
      shipmentId: window.shipmentId,
      merchandiseId,
      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType: PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
            elements: PGAItemsArray.elements,
          },
        ],
      },
    });
  } else
    dataSent = savePGAFormEvent({
      level: level,
      merchandiseId,
      deltaUpdate: true,
      shipmentId: window.shipmentId,
      invoiceId,
      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType: PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
            elements: PGAItemsArray.elements,
          },
        ],
      },
    });
  return HttpPostRequest(dataSent);
};
//saveECCC
export const savePGAItemFieldEccc = (
  PGAItemsArray,
  merchandiseId,
  formType,
  level,
  invoiceId
) => {
  // console.log(PGAItemsArray, 'ITEMS')
  let dataSent;
  if (level === 0) {
    dataSent = savePGAFormEvent({
      level: level,
      invoiceId,
      merchandiseId,
      shipmentId: window.shipmentId,
      deltaUpdate: true,

      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType:
                PGAItemsArray.pgaPayload?.cbsaPgaSubProgramType ||
                PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
            elements: PGAItemsArray.elements,
          },
        ],
      },
    });
  } else if (level === 5) {
    dataSent = savePGAFormEvent({
      level: 0,
      invoiceId,
      merchandiseId,
      shipmentId: window.shipmentId,
      deltaUpdate: true,

      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType:
                PGAItemsArray.pgaPayload?.cbsaPgaSubProgramType ||
                PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
            // elements: PGAItemsArray.elements,
          },
        ],
      },
    });
  } else if (level === 1) {
    dataSent = savePGAFormEvent({
      level: level,
      deltaUpdate: true,
      merchandiseId,
      invoiceId,
      shipmentId: window.shipmentId,

      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType:
                PGAItemsArray.pgaPayload?.cbsaPgaSubProgramType ||
                PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
            elements: PGAItemsArray.elements,
          },
        ],
      },
    });
  } else {
    dataSent = savePGAFormEvent({
      level: level,
      invoiceId,
      merchandiseId,
      deltaUpdate: true,
      shipmentId: window.shipmentId,

      pgaDetails: {
        pgaDetails: [
          {
            pga: {
              cbsaPgaType: formType,
              cbsaPgaSubProgramType: PGAItemsArray?.pgaPayload
                ? PGAItemsArray.pgaPayload?.cbsaPgaSubProgramType
                : PGAItemsArray.pga?.cbsaPgaSubProgramType,
            },
            elements: PGAItemsArray.elements,
          },
        ],
      },
    });
  }

  return HttpPostRequest(dataSent);
};

//
export const savePgaComingFromProductHistoryLinesResponse = (
  pgaDetails,
  merchandiseId,
  invoiceId
) => {
  let dataSent = savePGAFormEvent({
    level: 2,
    merchandiseId,
    deltaUpdate: true,
    shipmentId: window.shipmentId,
    pgaDetails,
  });
  return HttpPostRequest(dataSent);
};
//
// save CFIAPayor
export const savePGAItemPayorField = (
  PGAItemsArray,
  merchandiseId,
  formType,
  level,
  invoiceId
) => {
  let dataSent;
  dataSent = savePGAFormEvent({
    level: 0,
    deltaUpdate: true,
    invoiceId,
    merchandiseId,
    shipmentId: window.shipmentId,

    pgaDetails: {
      pgaDetails: [
        {
          pga: {
            cbsaPgaType: formType,
            cbsaPgaSubProgramType: PGAItemsArray?.pga
              ? PGAItemsArray.pga?.cbsaPgaSubProgramType
              : PGAItemsArray?.pgaPayload?.cbsaPgaSubProgramType,
          },
          elements: PGAItemsArray.elements,
        },
      ],
    },
  });
  return HttpPostRequest(dataSent);
};

export const saveInvoicePGAItemField = (PGAItemsArray, invoiceId, formType) => {
  let dataSent = savePGAFormEvent({
    level: 1,
    deltaUpdate: true,
    invoiceId,
    shipmentId: window.shipmentId,

    pgaDetails: {
      pgaDetails: [
        {
          pga: {
            cbsaPgaType: formType,
            cbsaPgaSubProgramType: PGAItemsArray.pga?.cbsaPgaSubProgramType,
          },
          elements: PGAItemsArray.elements,
        },
      ],
    },
  });
  return HttpPostRequest(dataSent);
};

export const savePgaFlag = (merchandiseId, field, payload) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          [field]: payload,
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const savePgaDetailsFlag = (
  merchandiseId,
  value,
  elements,
  cbsaPgaType,
  cbsaPgaSubProgramType
) => {
  let dataSent = savePGAEvent({
    level: 2,
    merchandiseId,
    shipmentId: window.shipmentId,

    pgaDetails: {
      pgaDetails: [
        {
          pga: {
            cbsaPgaType: cbsaPgaType,
            cbsaPgaSubProgramType: cbsaPgaSubProgramType,
          },
          elements,
        },
      ],
    },
  });
  return HttpPostRequest(dataSent);
};

export const saveDomHeaderPartyName = (
  invoiceId,
  merchandiseId,
  manufacturerId,
  fieldName,
  value
) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems:
        manufacturerId != 0 || !!manufacturerId
          ? [
              {
                invoiceId,
                merchandiseId,
                manufacturerId,
                [fieldName]: value,
              },
            ]
          : [
              {
                invoiceId,
                merchandiseId,
                [fieldName]: value,
              },
            ],
    },
    shipmentId: window.shipmentId,
  });
  // console.log("conconconcon1",dataSent)
  return HttpPostRequest(dataSent);
};

export const saveDomHeaderPartyAddress = (
  formType,
  invoiceId,
  merchandiseId,
  manufacturerId,
  address
) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: 
      manufacturerId != 0 || !!manufacturerId
      ?
      [
        {
          invoiceId,
          merchandiseId,
          manufacturerId,
          mfgAddressInfo: buildRequestAddress(address),
        },
      ]:
      [
        {
          invoiceId,
          merchandiseId,
          mfgAddressInfo: buildRequestAddress(address),
        },
      ]
      ,
    },
    shipmentId: window.shipmentId,
  });
  return HttpPostRequest(dataSent);
};

export const saveDOIHeaderPartyName = (
  formType,
  invoiceId,
  merchandiseId,
  vendorId,
  fieldName,
  value
) => {
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      invoices: ["VENDOR","vendor"].includes(formType)? [

        {
          invoiceId,
          vendorId,
          [fieldName]: value,
        },
      ]: [
        {
          invoiceId,
          manufacturerId:vendorId,
          [fieldName]: value,
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const saveDOIWaiverStatus = (
  invoiceId,
  manufacturerId,
  fieldName,
  value
) => {
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      invoices: manufacturerId ? [
        {
          invoiceId,
          manufacturerId,
          [fieldName]: value,
        },
      ]:[
        {
          invoiceId,
          [fieldName]: value,
        },
      ],
    },
    shipmentId: window.shipmentId,
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const saveDOIHeaderPartyAddress = (
  formType,
  invoiceId,
  merchandiseId,
  vendorId,
  address
) => {
  let dataSent = saveEvent({
    descriptionOfInvoice: {
      invoices: ["VENDOR","vendor"].includes(formType)? [

        {
          invoiceId,
          vendorId,
          addressInfo: buildRequestAddress(address),
        },
      ]:
      [

        {
          invoiceId,
          manufacturerId:vendorId,
          mfgAddressInfo: buildRequestAddress(address),
        },
      ]
      ,
    },
    shipmentId: window.shipmentId,
  });
  if (window.typeOfUser !== 'BROKER_KN_ADMIN') {
    return HttpPostRequest(dataSent);
  }
};

export const addNotesItem = (description, createdBy, hotCheckBox) => {
  let dataSent = {
    eventType: 'SAVE_SHIPMENT_NOTES',
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      status: '0',
      description,
      hot: hotCheckBox === true ? '1' : '0',
      userName: createdBy,
      dateOfNote: { epochs: new Date().getTime() },
    },
  };

  return dataSent;
};

export const saveNotes = (noteId, fieldName, value) => {
  let dataSent = {
    eventType: 'SAVE_SHIPMENT_NOTES',
    eventTime: Date.now(),
    eventMessage: {
      noteId,
      [fieldName]: value,
      shipmentId: window.shipmentId,
    },
  };

  return HttpPostRequest(dataSent);
};
